import { render, staticRenderFns } from "./AgreementChukyo.vue?vue&type=template&id=5cac36d9&scoped=true&"
import script from "./AgreementChukyo.vue?vue&type=script&lang=ts&"
export * from "./AgreementChukyo.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementChukyo.vue?vue&type=style&index=0&id=5cac36d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac36d9",
  null
  
)

export default component.exports